"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInShoppingPage = void 0;
/**
 * Legacy way to determine if in basket page.
 * TODO: Rather do a condition in BE code to not have to call this check. Then remove ASAP.
 * @deprecated
 */
const isInShoppingPage = () => window.location.pathname.split('/').includes('shopping');
exports.isInShoppingPage = isInShoppingPage;
